.textContainer {
    max-width: 100px;
    display: flex;
    align-items: center;
    width: 100%;
}
.totalContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.controlRow {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.controlTextContainer {
    display: flex;
    flex-direction: column;
}

.equalizeButton {
    margin-top: 20px;
}
